export enum BusinessLocationType {
  dropOff = 'DROP_OFF',
  pickUp = 'PICK_UP',
  walkablePoint = 'WALKABLE',
  default = 'DEFAULT',
  // DISPLAY,
  // ROUTABLE,
}
